<template>
  <div class="notice-list">
    <associationNotice @changePage="changePage" @click="toDetails" :list="notice" :total="noticeTotal" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';
export default {
  components:{
    associationNotice
  },
  data(){
    return {
      loading:false,
      notice:[
        // {
        //   title:'扎根东区十五载，一本"民情笔记"里的温情与守望',
        //   date:'2025-12-15'
        // },
        // {
        //   title:'闻令而动！看协会应急服务队的先锋社工们如何守护社区平安',
        //   date:'2025-12-14'
        // },
        // {
        //   title:'从"新手"到"专家"：一位专业社工在老年服务领域的深耕之旅',
        //   date:'2025-12-14'
        // },
        // {
        //   title:'当社工服务遇上"新潮玩法"：看年轻社工团队如何创新服务形式',
        //   date:'2025-12-11'
        // },
        // {
        //   title:'"最佳拍档"：记录协会里那些携手服务社区的社工伙伴',
        //   date:'2025-12-11'
        // },
        // {
        //   title:'双肩挑的社区"领头雁"：一位会员书记的社区治理实践记',
        //   date:'2025-12-05'
        // },
        // {
        //   title:'退而不休的"银龄社工"：看协会长者会员如何续写奉献新篇',
        //   date:'2025-12-05'
        // },
        // {
        //   title:'三年考取三项高级证书的背后：一位社工的专业攀登之路',
        //   date:'2025-12-05'
        // },
        // {
        //   title:'资源链接的"社区枢纽"：记一位为困难家庭编织支持网络的社工',
        //   date:'2025-12-03'
        // },
        // {
        //   title:'00后"社工的初体验：在服务中遇见感动，在实践中坚定初心',
        //   date:'2025-12-03'
        // }
      ],
      noticeTotal:0,
      currentPage:1
    }
  },
   created(){
    this.getList()
  },
  methods:{
    ...mapMutations('routerData',['changeRouterList']),
    getList(){
      dynamics({
        current:this.currentPage,
        size:10,
        type:16
      }).then(res=>{
        if(res.data.code==200){
          this.noticeTotal=res.data.data.total
          this.notice=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      })
    },
    toDetails(data){
      this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
      )
      let routerList=[]
      let routers = ['/memberService','memberServiceMemberShowcase', '/associationNews/details'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
        routerList.push(routerData)
      }
      this.changeRouterList(routerList)
    },
    changePage(page){
      this.currentPage=page
      this.getList()
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.notice-list {
  width: 100%;
}
</style>
